import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import GriffinName from 'griffin-paypal/lib/client/name';
import { getInitialFormValues } from '../../../config/form';
import { FORM_ID } from '../../../../framework/App/AppConstants';
import FirstName, { isValidFirstName } from '../../../components/FirstName/FirstName';
import LastName, { isValidLastName } from '../../../components/LastName/LastName';
import StreetGroup from '../../../components/Address/StreetGroup/StreetGroup';
import City from '../../../components/Address/City/City';
import State from '../../../components/Address/State/State';
import ZipCode from '../../../components/Address/ZipCode/ZipCode';
import Col from '../../../../shared-components/VXGrid/Col';
import Row from '../../../../shared-components/VXGrid/Row';
import { handleSubmitFail } from '../../../../shared-components/FormElement/FormElementUtils';
import _ from 'lodash';

export class BillingAddressForm extends Component {
    static propTypes = {
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        intl: intlShape.isRequired,
        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,
        // http://redux-form.com/6.7.0/docs/api/ReduxForm.md/#-onsubmit-function-optional-
        // Injected into decorated reduxForm() component; callback after successful validation
        onSubmit: PropTypes.func.isRequired,
        griffinNameHandler: PropTypes.object.isRequired,
        shouldLogPOBoxAddressInSplunk: PropTypes.bool,
        shouldLogMilitaryAddressInSplunk: PropTypes.bool
    };


    render() {
        const LOCALE_PREFIX = 'US/pages/BillingAddressPage/BillingAddressForm';
        const { intl, firstName, lastName, handleSubmit, griffinNameHandler } = this.props;
        const personalNameErrorMessage = intl.formatMessage({id: `${LOCALE_PREFIX}.personal-name-invalid`});
        return (
            <Form id="billing-address-form" onSubmit={handleSubmit} autoComplete="off">
                {!firstName &&
                <FirstName
                    validations={[isValidFirstName(personalNameErrorMessage, griffinNameHandler)]}
                />}
                {!lastName &&
                <LastName
                    validations={[isValidLastName(personalNameErrorMessage, griffinNameHandler)]}
                />}
                <StreetGroup {...this.props} />
                <Row gutterSize={10}>
                    <Col xs={6}>
                        <City />
                    </Col>
                    <Col xs={3}>
                        <State />
                    </Col>
                    <Col xs={3}>
                        <ZipCode />
                    </Col>
                </Row>
            </Form>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const initialValues = getInitialFormValues(state);
    //don't pre-populate phone number on BillingAddressPage
    initialValues.telephone = '';

    return {
        initialValues,
        firstName: ownProps.firstName,
        lastName: ownProps.lastName,
        griffinNameHandler: GriffinName.createHandler(state.serverData.localityMetadata),
        shouldLogPOBoxAddressInSplunk: _.get(state, 'serverData.featureFlags.wireOnPOBoxAddressSplunkLogging', false),
        shouldLogMilitaryAddressInSplunk: _.get(state, 'serverData.featureFlags.wireOnMilitaryAddressSplunkLogging', false)
    };
};

export default connect(mapStateToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        onSubmitFail: handleSubmitFail,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(BillingAddressForm)
));
